import { PropsWithChildren, useEffect } from "react";
import axios from "axios";
import type { AxiosResponse } from "axios";

import { ClientContext, ClientContextProps } from "./client-context";
import QueryProvider from "./QueryProvider";

type ClientProviderProps = ClientContextProps & {
  axiosInterceptorSuccess?: (
    r: AxiosResponse<any, any>,
  ) => AxiosResponse["data"];
  axiosInterceptorError?: (err: any) => void;
};

export default function ClientProvider({
  children,
  accessToken,
  basePath,
  axiosInterceptorSuccess,
  axiosInterceptorError,
}: PropsWithChildren<ClientProviderProps>) {
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      axiosInterceptorSuccess ||
        function (r) {
          if (!r) return Promise.reject(new Error("No response"));
          return r.data;
        },
      axiosInterceptorError ||
        function (e) {
          Promise.reject(e);
        },
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  return (
    <ClientContext.Provider
      value={{
        accessToken,
        basePath,
      }}
    >
      <QueryProvider>{children}</QueryProvider>
    </ClientContext.Provider>
  );
}
